import styled from "@emotion/styled";
import { hideScrollbar } from "src/scrollbar";

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;

export const ArrowContainer = styled.div<{ $visible: boolean }>`
  display: ${({ $visible }) => ($visible ? "flex" : "none")};
  flex-shrink: 0;
`;

export const LeftArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-right: 16px;
  padding: 0;
  border: none;
  background: ${({ theme }) => theme.colors?.tone.white};
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: ${({ theme }) => theme.colors?.tone.marble};
  }
`;

export const RightArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-left: 16px;
  padding: 0;
  border: none;
  background: ${({ theme }) => theme.colors?.tone.white};
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: ${({ theme }) => theme.colors?.tone.marble};
  }
`;

export const ScrollArea = styled.div<{ $gap?: string }>`
  display: flex;
  flex: 1;
  min-width: 0;
  gap: ${({ $gap, theme }) => $gap || theme.space?.space8};
  overflow-x: auto;
  scroll-behavior: smooth;
  ${hideScrollbar}

  & > *:last-child {
    margin-right: 48px;
  }
`;
